// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function IconHeart(Props) {
  return React.createElement("svg", {
    style: {
      height: "16px",
      width: "18px"
    },
    height: "16",
    width: "18",
    fill: "none",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M16.1232 1.56352C18.2243 3.3644 18.3243 6.56597 16.4567 8.50024L9.98691 15.1702C9.78681 15.3703 9.52001 15.4703 9.21986 15.4703C8.95307 15.4703 8.68627 15.3703 8.48617 15.1702L2.01635 8.50024C0.148771 6.56597 0.248819 3.3644 2.34984 1.56352C3.15024 0.863182 4.15072 0.529686 5.15121 0.529686C6.38515 0.529686 7.65243 1.06328 8.58622 1.99707L9.25321 2.69741L9.88686 1.99707C10.8206 1.06328 12.0879 0.529686 13.3219 0.529686C14.3224 0.529686 15.3228 0.863182 16.1232 1.56352ZM15.2895 7.39971C16.39 6.26582 16.6235 4.09809 15.0894 2.79746C13.7554 1.63022 11.9212 2.23052 11.0541 3.13096L9.25321 4.99853L7.41899 3.13096C6.5519 2.19717 4.71767 1.63022 3.38368 2.79746C1.8496 4.09809 2.1164 6.26582 3.18359 7.39971L9.25321 13.6361L15.2895 7.39971Z",
    fill: "currentColor"
  }));
}
IconHeart.displayName = "IconHeart";
var make = IconHeart;
export { make };
/* react Not a pure module */